'use strict'

module.exports = function (node) {
  var condition = '!!(' + this.next(node.condition) + ')'
  var trueExpr = this.next(node.trueExpr)
  var falseExpr = this.next(node.falseExpr)
  return '(' + condition + ' ? (' + trueExpr + ') : (' + falseExpr + ') )'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-codegen/lib/node/ConditionalNode.js
// module id = 87Vc
// module chunks = 0